import type { WhyScope } from './types';

/**
 * react-query keys for the account (frontend-conventions §7.5.1).
 *
 * DELIBERATELY NOT under `['disruptions', urn, …]`. The case-scoped view is
 * keyed by the CASE and only learns its disruption from the answer, so one flat
 * `['why', <scope>, <urn>]` root keeps both reads addressable by the same
 * predicate — which is exactly what the `NarrativeChanged` merge in
 * `lib/ws/apply-event.ts` walks (it patches EVERY cached view belonging to the
 * disruption, disruption-scoped and case-scoped alike).
 */
export const WHY_KEY_ROOT = 'why';

export function whyDisruptionKey(disruptionUrn: string): readonly unknown[] {
  return [WHY_KEY_ROOT, 'disruption', disruptionUrn];
}

export function whyCaseKey(caseUrn: string): readonly unknown[] {
  return [WHY_KEY_ROOT, 'case', caseUrn];
}

export function whyKey(scope: WhyScope): readonly unknown[] {
  return scope.kind === 'disruption'
    ? whyDisruptionKey(scope.disruptionUrn)
    : whyCaseKey(scope.caseUrn);
}
